import React from 'react';
import { Provider } from 'react-redux';

import configureStore from '../store/eventSubmissionStore';
import Layout from '../layout/Layout';
import AppContainer from 'containers/AppContainer';
import SecureCheckoutPage from 'containers/SecureCheckoutPage';
import { StripeProvider } from 'react-stripe-elements';
import styles from './OneStepCheckout.scss';


const OneStepCheckout = (props) => (
  <Provider store={configureStore(props)}>
    <Layout>
      <AppContainer>
        <StripeProvider apiKey={props.stripe_key}>
          <SecureCheckoutPage className={styles.oneStepCheckout}/>
        </StripeProvider>
      </AppContainer>
    </Layout>
  </Provider>
);

export default OneStepCheckout;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/startup/OneStepCheckout.jsx